import React, { Component } from 'react';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

class CookiesName extends Component {
    static propTypes = {
		cookies: instanceOf(Cookies).isRequired
	};
	constructor(props) {
		super(props);
		this.state = {
			name: props.cookies.get('name') || 'Ben'
		};
	}

	handleNameChange = (name) => {
		const { cookies } = this.props;	 
		//console.log('cookies', cookies);
		cookies.set('name', name, { path: '/' });
		this.setState({ name });

      }
      
    render() {
		const { cookies } = this.props;
		let show = cookies.cookies && cookies.cookies.name;
		//console.log('cookies', show);
        return (
            <>
				{(show === undefined) && <div className="cookies">
					<h1>Your privacy</h1>
					<p>We use cookies to ensure the functionality of our website, to personalize content and advertising, to provide social media features, and to analyze our traffic. If you allow us to do so, we also inform our social media, advertising and analysis partners about your use of our website. You can decide for yourself which categories you want to deny or allow. Please note that based on your settings not all functionalities of the site are available.</p>
					<button className="btn btn-primary btn-sm" type="button" onClick={() => this.handleNameChange('Update')}>Accept All Cookies</button>
					
				</div>}
            </>
        );
    }
}

export default withCookies(CookiesName);